import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import Dashboard from '@/components/Dashboard';
import Profile from '@/components/Profile';
import PasswordReset from '@/components/PasswordReset';
import People from '@/components/People';
import Person from '@/components/Person';
import Companies from '@/components/Companies';
import Company from '@/components/Company';
import Destinations from '@/components/Destinations';
import Destination from '@/components/Destination';
import TourCategories from '@/components/TourCategories';
import TourCategory from '@/components/TourCategory';
import ServiceTypes from '@/components/ServiceTypes';
import ServiceType from '@/components/ServiceType';
import SupplierServices from '@/components/SupplierServices';
import SupplierService from '@/components/SupplierService';
import PaymentAccounts from '@/components/PaymentAccounts';
import PaymentAccount from '@/components/PaymentAccount';
import UserAccounts from '@/components/UserAccounts';
import UserAccount from '@/components/UserAccount';
import Invoices from '@/components/Invoices';
import Invoice from '@/components/Invoice';
import Payments from '@/components/Payments';
import Tours from '@/components/Tours';
import Tour from '@/components/Tour';
import CashFlowBuyers from '@/components/CashFlowBuyers';
import CashFlowSuppliers from '@/components/CashFlowSuppliers';
import TourProfit from '@/components/TourProfit';

Vue.use(Router);

export default new Router({
	routes: [
		{path: '/dashboard', name: 'dashboard', component: Dashboard, meta: {}},
		{path: '/login', name: 'login', component: Login, meta: {}},
		{path: '/reset-password/:token', name: 'reset-password', component: PasswordReset, meta: {}},
		{path: '/profile', name: 'profile', component: Profile, meta: {}},
		{path: '/people', name: 'people', component: People, meta: {}},
		{path: '/people/:id', name: 'person', component: Person, meta: {}},
		{path: '/companies', name: 'companies', component: Companies, meta: {}},
		{path: '/companies/:id', name: 'company', component: Company, meta: {}},
		{path: '/destinations', name: 'destinations', component: Destinations, meta: {}},
		{path: '/destinations/:id', name: 'destination', component: Destination, meta: {}},
		{path: '/tour-categories', name: 'tourCategories', component: TourCategories, meta: {}},
		{path: '/tour-categories/:id', name: 'tourCategory', component: TourCategory, meta: {}},
		{path: '/service-types', name: 'serviceTypes', component: ServiceTypes, meta: {}},
		{path: '/service-types/:id', name: 'serviceType', component: ServiceType, meta: {}},
		{path: '/supplier-services', name: 'supplierServices', component: SupplierServices, meta: {}},
		{path: '/supplier-services/:id', name: 'supplierService', component: SupplierService, meta: {}},
		{path: '/payment-accounts', name: 'paymentAccounts', component: PaymentAccounts, meta: {}},
		{path: '/payment-accounts/:id', name: 'paymentAccount', component: PaymentAccount, meta: {}},
		{path: '/user-accounts', name: 'userAccounts', component: UserAccounts, meta: {}},
		{path: '/user-accounts/:id', name: 'userAccount', component: UserAccount, meta: {}},
		{path: '/invoices', name: 'invoices', component: Invoices, meta: {}},
		{path: '/invoices/:id/:action', name: 'invoice', component: Invoice, meta: {}},
		{path: '/payments', name: 'payments', component: Payments, meta: {}},
		{path: '/tours', name: 'tours', component: Tours, meta: {}},
		{path: '/tours/:id', name: 'tour', component: Tour, meta: {}},
		{path: '/cash-flow-buyers', name: 'cashFlowBuyers', component: CashFlowBuyers, meta: {}},
		{path: '/cash-flow-suppliers', name: 'cashFlowSuppliers', component: CashFlowSuppliers, meta: {}},
		{path: '/tour-profit', name: 'tourProfit', component: TourProfit, meta: {}},
	]
});


